import React from 'react';
import {
    Redirect, Route, Router as BaseRouter, Switch,
} from 'react-router-dom';

import { NotYetImplemented } from '../../lib/PST.Web.Common/src/scenes/NotYetImplemented/NotYetImplemented';
import { history } from '../../lib/PST.Web.Common/src/services/history/history';
import { LoadablePageCGU } from '../../scenes/CGU/LoadablePageCGU';
import { Page403 } from '../../scenes/Page403/Page403';
import { FormationRouter } from '../FormationRouter/FormationRouter';
import { HomeRouter } from '../HomeRouter';
import { LoadableNewsDetailsPage } from '../../scenes/NewsDetailsPage/LoadableNewsDetailsPage';

export const DEFAULT_ROUTE = '/home';

const Router = () => (
    <BaseRouter history={history}>
        <Switch>
            <Route exact path="/403" component={Page403} />

            {/* HOME */}
            <Route path="/home" render={() => <HomeRouter defaultRoute={DEFAULT_ROUTE} Page403={Page403} />} />

            {/* FORMATION */}
            <Route
                path="/formations"
                render={() => <FormationRouter defaultRoute={DEFAULT_ROUTE} Page403={Page403} />}
            />

            {/* NEWS */}
            <Route exact path="/news/details/:id" component={LoadableNewsDetailsPage} Page403={Page403} />

            {/* CGU */}
            <Route path="/CGU" component={LoadablePageCGU} Page403={Page403} />

            <Route exact path="/404" component={NotYetImplemented} />

            <Redirect to={DEFAULT_ROUTE} />
        </Switch>
    </BaseRouter>
);

export { Router };
